import {
    CookieType,
    ThirdPartyScript,
} from "web/script/analytics/third_party_scripts/third-party-scripts";

export class TrustpilotWidget implements ThirdPartyScript {
    cookieType = "analytics" as CookieType;

    async load(): Promise<void> {
        return new Promise((resolve) => {
            (function (d): void {
                let head = d.getElementsByTagName("head")[0];
                let script = d.createElement("script");
                script.async = true;
                script.src = "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
                script.addEventListener("load", () => {
                    resolve();
                });
                head.appendChild(script);
            })(document);
        });
    }
}
